/**
 * Entry application component used to compose providers and render Routes.
 * */

import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';
import Routes from '../app/Routes';
import { I18nProvider } from '../_metronic/i18n';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import MetaTags from './components/MetaTags';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { useMuiTheme } from '../_metronic/theme/createMuiTheme';

const queryClient = new QueryClient();

const ChildApp = () => {
  const muiTheme = useMuiTheme();
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <MetaTags />
      <Routes />
      <ReactQueryDevtools initialIsOpen={false} />
    </ThemeProvider>
  );
};

export default function App({ store, persistor, basename }) {
  return (
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<div>Loading Persisted Data...</div>}>
        {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
        <React.Suspense fallback={<div>Loading Application Data...</div>}>
          {/* Override `basename` (e.g: `homepage` in `package.json`) */}
          <BrowserRouter basename={basename}>
            {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
            {/* <MaterialThemeProvider> */}
            {/* Sync list/dashboard filter + pagination state into the URL query string. */}
            <QueryParamProvider
              adapter={ReactRouter5Adapter}
              options={{ updateType: 'replaceIn', removeDefaultsFromUrl: true }}
            >
              {/* Provide `react-intl` context synchronized with Redux state.  */}
              <I18nProvider>
                {/* Render routes with provided `Layout`. */}
                <QueryClientProvider client={queryClient}>
                  {/* <CssBaseline />
                  <MetaTags />
                  <Routes /> */}
                  <ChildApp />
                  <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
              </I18nProvider>
            </QueryParamProvider>
            {/* </MaterialThemeProvider> */}
          </BrowserRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
